'use client'

import Link from 'next/link'

import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Pixl from '@/components/mdx/Pixl'
import type { ArticleMeta } from '@/lib/articles'
import styles from './page.module.css'

function categoryLabel(category: ArticleMeta['category']) {
  return category === 'guide' ? 'Guide' : 'Update'
}

function Media({ article, className }: { article: ArticleMeta; className: string }) {
  return (
    <div className={`${styles.media} ${className}`}>
      {article.image ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={article.image} alt="" className={styles.mediaImg} />
      ) : article.icon ? (
        <Pixl name={article.icon} />
      ) : null}
    </div>
  )
}

export default function ArticlesIndex({ articles }: { articles: ArticleMeta[] }) {
  const featured = articles[0]
  const rest = articles.slice(1)

  return (
    <div style={{ maxWidth: 'var(--MaxWidth)', margin: '0 auto' }}>
      <Nav />
      <main className={styles.main}>
        <div className={styles.inside}>
          <h1 className={styles.title}>Articles</h1>

          {!featured ? (
            <p className={styles.empty}>Nothing here yet — check back soon.</p>
          ) : (
            <>
              <Link href={`/articles/${featured.slug}`} className={styles.featured}>
                <Media article={featured} className={styles.featuredMedia} />
                <div className={styles.featuredBody}>
                  <span className={styles.category}>{categoryLabel(featured.category)}</span>
                  <h2 className={styles.featuredTitle}>{featured.title}</h2>
                  <p className={styles.featuredDesc}>{featured.description}</p>
                </div>
              </Link>

              {rest.length > 0 && (
                <div className={styles.grid}>
                  {rest.map((article) => (
                    <Link
                      key={article.slug}
                      href={`/articles/${article.slug}`}
                      className={styles.card}
                    >
                      <Media article={article} className={styles.cardMedia} />
                      <span className={styles.category}>{categoryLabel(article.category)}</span>
                      <h3 className={styles.cardTitle}>{article.title}</h3>
                      <p className={styles.cardDesc}>{article.description}</p>
                    </Link>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  )
}
